// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1NlHK","insightsList":"newBusinessInsightsMenu_insightsList__RuWdI","active":"newBusinessInsightsMenu_active__3pUei"};